<template src="./ReportButtonSP.html"></template>

<script>
/**
 * 個別銘柄レポートボタンコンポーネント(SP用)
 * @module modules/Stocks/ReportButtonSP
 */
export default {
  name: 'ReportButtonSP',
  props: {
    /**
     * 金融アイテムコード
     * @type {string}
     */
    code: {
      type: String,
      required: true,
    },
  },
  computed: {
    /**
     * レポート銘柄登録済みかどうか
     * @returns {boolean}
     */
    isReported() {
      return this.$store.getters['reportFinancialItems/isReported'](this.code);
    },
    /**
     * レポート銘柄登録数が最大かどうか
     * @returns {boolean}
     */
    isFull() {
      return this.$store.getters['reportFinancialItems/isFull'];
    },
    /**
     * ボタン計測用のタグ
     * @returns {string}
     */
    toggleGoogleTag() {
      return this.isReported ? 'report_remove' : 'report_add';
    },
  },
  created() {
    this.$store.dispatch('reportFinancialItems/init');
  },
  methods: {
    /**
     * モーダルを表示する
     * @returns {boolean}
     */
    show() {
      if (this.isLoggedIn) {
        if (this.isReported) {
          this.$store.commit('reportModal/showReported');
        } else {
          if (this.isFull) {
            this.$store.commit('reportModal/showFull');
          } else {
            this.$store.commit('reportModal/showReportable');
          }
        }
      } else {
        this.$store.commit('reportModal/showSignUp');
      }
      return false;
    },
  },
};
</script>
